<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="incomes-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Przychody</h1>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="incomes"
      class="elevation-1"
      :loading="loading"
      :search="search"
      :options.sync="options"
      :server-items-length="totalItems"
    >
      <template v-slot:top>
        <div class="table-section-title">
          <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-cash-plus</v-icon></div>
          <div class="filter-title">{{ $t('incomes.title') }}</div>
          <v-spacer></v-spacer>
          <button class="action-pill action-pill--primary" @click="((dialog = true), (currentIncomeId = null))">
            <v-icon left small>mdi-plus</v-icon>
            {{ $t('common.add') }}
          </button>
        </div>
            <div>
              <v-row class="mx-2">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    :label="$t('common.search')"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="startDateMenu"
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="dark-date-picker"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        :label="$t('common.dateFrom')"
                        outlined
                        dense
                        hide-details
                        readonly
                        clearable
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearStartDate"
                      />
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      no-title
                      scrollable
                      first-day-of-week="1"
                      :locale="$i18n.locale"
                      @input="startDateMenu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="endDateMenu"
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="dark-date-picker"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="endDate"
                        :label="$t('common.dateTo')"
                        outlined
                        dense
                        hide-details
                        readonly
                        clearable
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearEndDate"
                      />
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      no-title
                      scrollable
                      first-day-of-week="1"
                      :locale="$i18n.locale"
                      @input="endDateMenu = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoIncome(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
          <template v-slot:item.deleteIncome="{ item }">
            <v-btn class="error" @click="deleteIncome(item.id)"
              ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
    <v-dialog content-class="dark-form-dialog" v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('incomes.formTitle') }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" @submit.prevent="submitIncome">
            <v-row>
              <!-- File Upload with Preview -->
              <v-col cols="12">
                <v-file-input
                  v-model="income.file"
                  :label="$t('incomes.file')"
                  outlined
                  accept="image/*,.pdf, image/*"
                  @change="previewFile"
                />
                <iframe
                  v-if="income.preview"
                  :src="income.preview"
                  style="width: 100%; height: 400px"
                  frameborder="0"
                ></iframe>
              </v-col>
              <v-col cols="12" md="12">
                <v-menu
                  ref="dateMenu"
                  v-model="menuDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="income.date"
                      :label="$t('common.date')"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[validateRequired]"
                    />
                  </template>
                  <v-date-picker
                    v-model="income.date"
                    no-title
                    scrollable
                    first-day-of-week="1"
                    :locale="$i18n.locale"
                    @input="menuDate = false"
                  />
                </v-menu>
              </v-col>
                          <v-col cols="12" md="6">
                <v-text-field
                  v-model="income.name"
                  :label="$t('common.description')"
                  outlined
                  required
                  type="text"
                  :rules="[validateRequired]"
                />
              </v-col>
              <!-- Brutto Input -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="income.brutto"
                  :label="$t('incomes.brutto')"
                  outlined
                  required
                  type="number"
                  :rules="[validateRequired]"
                  @input="calculateNetto"
                />
              </v-col>

              <!-- Tax Select -->
              <v-col cols="12" md="6">
                <v-select
                  v-model.number="income.tax"
                  :items="taxRates"
                  :label="$t('incomes.taxPercent')"
                  outlined
                  required
                  :rules="[validateRequired]"
                  @change="calculateNetto"
                />
              </v-col>

              <!-- Netto (Calculated) -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="income.netto"
                  :label="$t('incomes.netto')"
                  outlined
                  readonly
                />
              </v-col>


             
              <v-col cols="12" md="12">
                <v-select
                  v-model="income.type"
                  :items="incomeType"
                  :label="$t('common.status')"
                  outlined
                  required
                  :rules="[validateRequired]"
                />
              </v-col>
              <!-- Driver -->
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
                  <v-spacer></v-spacer>
          <!-- Cancel Button -->
          <v-btn text color="secondary" @click="dialog = false">{{ $t('common.cancel') }}</v-btn>
          <!-- Submit Button -->
          <v-btn color="primary" :disabled="!valid" @click="submitIncome">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      currentIncomeId: null,
      loading: false,
      menuDate: false,
      totalItems: 0,
      search: "",
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      incomes: [],
      headers: [
        {
          text: "Data",
          align: "start",
          sortable: false,
          value: "date",
        },
        {
          text: "Brutto",
          align: "start",
          sortable: false,
          value: "brutto",
        },
        {
          text: "Netto",
          align: "start",
          sortable: false,
          value: "netto",
        },
        {
          text: "Status",
          align: "start",
          sortable: false,
          value: "status",
        },
        { text: "", value: "details", sortable: false },
        { text: "", value: "deleteIncome", sortable: false },
      ],
      dialog: false,
      valid: false,
      income: {
        file: null,
        preview: null,
        brutto: null,
        netto: null,
        tax: null,
        name: null,
        returnToDriver: null,
        driverCost: null,
        positions: [],
        driver: null,
      },
      drivers: [],
      taxRates: [
        { text: "0%", value: 0 },
        { text: "5%", value: 5 },
        { text: "8%", value: 8 },
        { text: "22%", value: 22 },
        { text: "23%", value: 23 },
      ],
      returnToDriverOptions: [
        { text: "0%", value: 0 },
        { text: "25%", value: 25 },
        { text: "50%", value: 50 },
        { text: "75%", value: 75 },
        { text: "100%", value: 100 },
      ],
      incomeType: [
        { text: "Oczekujący", value: "PENDING" },
        { text: "Wypłata utworzona", value: "PAYOUT_CREATED" },
        { text: "Zapłacony", value: "PAID" },
      ],
    };
  },
  async created() {
    await this.initialize();
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    search: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    startDate: {
      handler() {
        this.initialize();
      },
    },
    endDate: {
      handler() {
        this.initialize();
      },
    },
  },
  methods: {
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    validateRequired(value) {
      return !!value || "To pole jest wymagane";
    },
    clearStartDate() {
      this.startDate = null;
    },
    clearEndDate() {
      this.endDate = null;
    },
    closeDialog() {
      this.dialog = false;
      this.currentIncomeId = undefined;
      this.$refs.form.resetValidation(); // Reset form validation
    },
    previewFile(file) {
      console.log(file);
      if (file && file instanceof File) {
        const reader = new FileReader();
        reader.onload = (e) => {
          console.log(e.target.result);
          this.income.preview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    calculateNetto() {
      if (this.income.brutto != null && this.income.tax != null) {
        const taxMultiplier = 1 + this.income.tax / 100;
        this.income.netto = (this.income.brutto / taxMultiplier).toFixed(2);
      }
    },
    calculateDriverCost() {
      if (this.income.netto != null && this.income.returnToDriver != null) {
        this.income.driverCost = (
          this.income.netto *
          (this.income.returnToDriver / 100)
        ).toFixed(2);
      }
    },
    async submitIncome() {
      // Process the income data here
      console.log("Income submitted:", this.income);
      await this.toggleLoading(true);
      if (!this.valid) return;
      // Combine predefined metadata with additional metadata
      const formData = new FormData();
      try {
        formData.append("file", this.income.file, this.income.file.name);
      } catch (e) {
        console.log("Missing Image");
      }
      formData.append("id", this.currentIncomeId || undefined);
      formData.append("name", this.income.name);
      formData.append("brutto", parseFloat(this.income.brutto));
      formData.append("taxRate", parseFloat(this.income.tax));
      formData.append("netto", parseFloat(this.income.netto));
      formData.append("date", this.income.date);
      formData.append("status", this.income.type);
      try {
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "incomes",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        });
        await this.initialize();
        await this.closeDialog();
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    async infoIncome(id) {
      await this.toggleLoading(true);
      try {
        const incomes = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "incomes/details/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.currentIncomeId = incomes.data.data.id;
        this.income.date = dayjs(incomes.data.data.date).format("YYYY-MM-DD");
        this.income.name = incomes.data.data.name;
        this.income.brutto = incomes.data.data.brutto / 100;
        this.income.netto = incomes.data.data.netto / 100;
        this.income.tax = incomes.data.data.taxRate;
        this.income.type = incomes.data.data.status;
        this.dialog = true;
        await this.toggleLoading(false);
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async initialize() {
      this.loading = true;
      if (this.search.trim().length > 0) {
        this.options.page = 1;
      }
      try {
        let url = process.env.VUE_APP_ROOT_API +
          `incomes/all?take=${this.options.itemsPerPage}&skip=${this.options.page}&search=${this.search}`;

        if (this.startDate) {
          url += `&startDate=${this.startDate}`;
        }
        if (this.endDate) {
          url += `&endDate=${this.endDate}`;
        }

        const incomes = await axios({
          method: "get",
          url: url,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.incomes = incomes.data.data.result.map((bonus) => {
          return {
            brutto: bonus.brutto / 100,
            tax: bonus.tax,
            netto: bonus.netto / 100,
            status: bonus.status,
            date: dayjs(bonus.date).format("DD-MM-YYYY"),
            id: bonus.id,
          };
        });
        this.totalItems = incomes.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    async deleteIncome(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "incomes/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.incomes-page {
  margin: -24px;
  padding: 24px;
  background: #181C28;
  min-height: calc(100vh - 64px);
  color: #E6EAF2;
}
.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-eyebrow {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5478FF;
  font-weight: 600;
}
.page-title {
  font-size: 28px;
  font-weight: 700;
  margin: 4px 0 0 0;
  color: #FFFFFF;
}
.table-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #2A3142;
}
.filter-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(84, 120, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.filter-title {
  font-size: 15px;
  font-weight: 600;
  color: #E6EAF2;
}
.action-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.action-pill--primary {
  background: #5478FF;
  color: #FFFFFF;
}
.action-pill--primary:hover {
  background: #3F62E8;
}
.incomes-page >>> .v-data-table {
  background: #232838 !important;
  color: #E6EAF2 !important;
  border-radius: 12px;
  border: 1px solid #2A3142;
}
.incomes-page >>> .v-data-table thead tr th {
  background: #1F2433 !important;
  color: #94A0B8 !important;
  border-bottom: 1px solid #2A3142 !important;
}
.incomes-page >>> .v-data-table tbody tr td {
  border-bottom: 1px solid #2A3142 !important;
  color: #E6EAF2 !important;
}
.incomes-page >>> .v-data-table tbody tr:hover {
  background: rgba(84, 120, 255, 0.06) !important;
}
.incomes-page >>> .v-text-field--outlined fieldset {
  border-color: #2A3142 !important;
}
.incomes-page >>> .v-text-field input,
.incomes-page >>> .v-select__selection {
  color: #E6EAF2 !important;
}
.incomes-page >>> .v-label {
  color: #94A0B8 !important;
}
.incomes-page >>> .v-dialog .v-card {
  background: #232838 !important;
  color: #E6EAF2 !important;
}
.incomes-page >>> .v-card__title,
.incomes-page >>> .v-card__text {
  color: #E6EAF2 !important;
}
</style>
